import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useSelfControlledFieldValue } from "@/components/assistant/useSelfControlledFieldValue";
import type { ComponentProps } from "react";

type InputProps = Omit<ComponentProps<typeof Input>, "value" | "onChange"> & {
  value: string;
  onValueChange: (value: string) => void;
};

export function SelfControlledInput({ value, onValueChange, ...props }: InputProps) {
  const [localValue, setLocalValue] = useSelfControlledFieldValue(value, onValueChange);
  return (
    <Input
      {...props}
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
    />
  );
}

type TextareaProps = Omit<ComponentProps<typeof Textarea>, "value" | "onChange"> & {
  value: string;
  onValueChange: (value: string) => void;
};

export function SelfControlledTextarea({ value, onValueChange, ...props }: TextareaProps) {
  const [localValue, setLocalValue] = useSelfControlledFieldValue(value, onValueChange);
  return (
    <Textarea
      {...props}
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
    />
  );
}
